








































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import CardListKunjungan from "@/components/kunjunganPasien/CardListKunjungan.vue";
import { storePasien } from "@/store/modules/pasien";
import CardPemeriksaan from "@/components/CardPemeriksaan.vue";
import { resepStore } from "@/store/modules/resep";
import CardDetailKunjungan from "@/components/kunjunganPasien/CardDetailKunjungan.vue";
import CardResepPenunjang from "@/components/kunjunganPasien/CardResepPenunjang.vue";
import http from "@/axios/http-common";
import CardSoap from "@/components/kunjunganPasien/CardSoap.vue";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
import CpptIntegratedList from "@/components/soap/CpptIntegratedList.vue";
import { muatDetailKunjungan } from "@/utils/riwayatKunjungan";

@Component({
  components: {
    CardListKunjungan,
    CardResepPenunjang,
    CardPemeriksaan,
    CardDetailKunjungan,
    CpptIntegratedList
  }
})
export default class CardKunjungan extends Vue {
  @Prop() rm: string;

  register = null;
  tab = "tab-riwayat-kunjungan";

  created() {}

  @Watch("$route")
  onRouteChange() {
    this.register = null;
  }

  // dataRegister(val) {
  //   storeSoap.act_on_soap_all(val);
  //   // this.getResepList(val);
  //   // storePenunjang.act_list_ro_byReg("11122233");
  //   // storePenunjang.act_list_lab_byReg("11122233");
  //   storePenunjang.act_list_ro_byReg(val);
  //   // storePenunjang.act_list_lab_byReg(val);

  //   storeResepFarmasi.act_list_resepFarmasi_byReg(val);
  //   console.log(val);

  //   // storePenunjang.act_list_lab_byRm(this.rm);
  // }

  // get stateuser() {
  //   return userModule.user;
  // }

  dataPasien(val) {
    this.register = val.register;

    muatDetailKunjungan({
      register: val.register,
      unitId: val.unit.id,
      masuk: val.masuk,
      keluar: val.keluar,
      rm: storePasien.identitasPasien?.rm
    });
  }
}
